import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService } from '../../services/auth.service';
import { NgxIndexedDB } from 'ngx-indexed-db';
import { Store } from '@ngrx/store';
import { FuncionesGlobales } from '../../utilerias/clases/funcionesGlobales';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { AuthActionTypes, LogInSuccess, LogOut, UpdateData } from '../actions/auth.actions';
import { AsignaPermisos, EliminaPermisos } from '../actions/permisos.actions';
import { AppState, selectPermisosState } from '../app.states';
import { SessionInitializer } from '../../services/session-initializer';
import { TokenService } from '../../services/token.service';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from '../actions/utils.action';
import { UserService } from 'app/core/user/user.service';

@Injectable()
export class AuthEffects {
    private db: NgxIndexedDB;
    permisosState: Observable<any>;
    private redireccionar = true; // Para indicar si vamos a redireccionar al home por defecto.

    /**
     * @description             Constructor de clase
     * @param actions           Acciones NgRX
     * @param authService       Servicio de autenticación seguridad V2
     * @param router            Modulo de routeo
     * @param store             Stire NgRX
     */
    constructor(
        private actions: Actions,
        private authService: AuthService,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private store: Store<AppState>,
        public sessionInitializer: SessionInitializer,
        public tokenService: TokenService,
        private _userService: UserService
    ) {
        this.db = new NgxIndexedDB(environment.nombreAplicacion, 1);
        this.store.select(selectPermisosState);
    }

    loginEffect$ = createEffect(() =>
        this.actions.pipe(
            ofType(AuthActionTypes.LOGIN),
            exhaustMap((data: any) =>
                of(this._userService.user).pipe(
                    tap((user: any) => {
                    }),
                    map((user: any) => LogInSuccess({ seguridad: data }))
                )
            )
        )
    );
    updateDataEffect$ = createEffect(
        () => 
        this.actions.pipe(
            ofType(AuthActionTypes.UPDATE_DATA),
            tap((data: any) => {
                console.log(data);
                this.db.openDatabase(1, (evt) => {
                    const objectStore = 
                        evt.currentTarget.result.createObjectStore(
                            'seguridad',
                            { keyPath: 'Id', autoIncrement: false }
                        );
                    objectStore.transaction.oncomplete = function () {
                        this.db
                            .transaction('seguridad', 'readwrite')
                            .objectStore('seguridad')
                    };
                })
                .then(() => {
                    this.db.getByKey('seguridad', 1).then((result) => {
                        if (result === undefined) {
                            this.db.add('seguridad', {
                                Id: 1,
                                seguridad: data.seguridad,
                            });
                        } else {
                            this.db.update('seguridad', {
                                Id: 1,
                                seguridad: data.seguridad,
                            });
                        }
                    })
                })
                .catch((error: any) => {
                    console.log(error);
                })
            })
        ), {
            dispatch: false
        }
    );
    LogInSuccess$ = createEffect(
        () =>
            this.actions.pipe(
                ofType(AuthActionTypes.LOGIN_SUCCESS),
                tap((user: any) => {
                    this.db
                        .openDatabase(1, (evt) => {
                            const objectStore =
                                evt.currentTarget.result.createObjectStore(
                                    'seguridad',
                                    { keyPath: 'Id', autoIncrement: false }
                                );
                            objectStore.transaction.oncomplete = function () {
                                this.db
                                    .transaction('seguridad', 'readwrite')
                                    .objectStore('seguridad');
                            };
                        })
                        .then(() => {
                            this.db.getByKey('seguridad', 1).then((result) => {
                                this.store.dispatch(
                                    AsignaPermisos({
                                        modulos:
                                            FuncionesGlobales.GetRecursividad(
                                                user.seguridad.permissions
                                                    .modules
                                            ),
                                    })
                                );

                                const data = user;

                                if (result === undefined) {
                                    this.db.add('seguridad', {
                                        Id: 1,
                                        seguridad: data.seguridad,
                                    });
                                } else {
                                    this.db.update('seguridad', {
                                        Id: 1,
                                        seguridad: data.seguridad,
                                    });
                                }
                                const redirectURL = data?.seguridad?.account?.configurado ? this._activatedRoute.snapshot.queryParamMap.get('redirectURL') : '/signed-in-redirect'; 
                                this.router.navigateByUrl(redirectURL);
                                if (!user.seguridad.user.twoFactor) {
                                    this.db.update('seguridad', {
                                        Id: 1,
                                        seguridad: data.seguridad,
                                    });
                                    this.sessionInitializer.state = true;
                                    this.store.dispatch(OcultarSpinner());

                                    if( data?.seguridad?.company?.length != 0 ){
                                        this.router.navigate(['factura/facturas/0/0/0/0/0/0/0/0']);
                                    }
                                    else{
                                        this.router.navigate(['cuenta/nonecompany']);
                                    }

                                }
                            });
                        })
                        .catch((error) => {
                            //console.log(error);
                            this.store.dispatch(EliminaPermisos());
                            this.store.dispatch(LogOut());
                        });
                })
            ),
        {
            dispatch: false,
        }
    );


}
